<template>
  <div class="coin">
    <!--头部-->
    <!--<van-nav-bar class="wallet-header" title="蚂蚁金币" left-arrow @click-left="onClickLeft" :border="false" />-->
    <div class="header">
      <div class="item">
        <div class="title">可用 (枚)</div>
        <div class="num"><span>{{ antCoinBalance | filter2 }}</span></div>
        <!--<div class="num">≈<span>{{ antCoinMoney | filter2 }}</span> 元</div>-->
      </div>
      <div class="item">
        <div class="title">待结算 (枚)</div>
        <div class="num"><span>{{ waitSettle | filter2 }}</span></div>
      </div>
    </div>
    <div class="tool">
      <div class="item-con">
        <!--<div class="item" @click="goCoinIn">
          <img class="img" src="../../../assets/my/wallet/recharge-icon.png" alt="">
          <p class="title">金币充值</p>
        </div>
        <div class="gray-line"></div>
        -->


        <div class="item cash-out-btn" @click="goCoinOut">
          <img class="img" :src="checkQiNiuUrl('FhMdRHxZzTl2saYwhpJFWM20NnK0')" alt="">
          <p class="title">转移</p>
        </div>
      </div>
    </div>
    <div class="bg-10px"></div>
    <div class="list-con">
      <!--
      <van-cell @click="goCoinInHistory" is-link>
        <template slot="title">
          <img class="list-con-img" :src="checkQiNiuUrl('Fo1w4WZXEcIDkdpEIAKhT-S9DXY-')" alt="">
          <span class="list-con-text">金币充值记录</span>
        </template>
      </van-cell>
      <van-cell @click="goCoinOutHistory" is-link>
        <template slot="title">
          <img class="list-con-img" :src="checkQiNiuUrl('Ft9v-Pl0lswewiJgRGh3EKPC-R5O')" alt="">
          <span class="list-con-text">转移记录</span>
        </template>
      </van-cell>
      -->
      <van-cell @click="goCoinHistory" is-link>
        <template slot="title">
          <img class="list-con-img" :src="checkQiNiuUrl('FgLwdZ8q-GNFD64R3qK9eF37RVHJ')" alt="">
          <span class="list-con-text">金币记录</span>
        </template>
      </van-cell>

    </div>
  </div>
</template>

<script>
  import { platformCoin, getAntIntegralWallet } from '@/api/wallet/integral'
  import { getWaitSettle } from '@/api/mall/mallSettle'
  export default {
    components: {
    },
    data () {
      return {
        userOpenId: this.session('userOpenId'),
        userInfo: this.session('userInfo'),
        code: 'AntCoin', // 金币代码
        antCoinBalance: 0, // 蚂蚁金币数量 AntCoin
        antCoinUnitPrice: 0, // 蚂蚁金币单价
        antCoinMoney: 0, // 蚂蚁金币 约等于 money
        waitSettle: 0,//待结算
      }
    },
    created() {
      this.myBalance()
      this.getWaitSettle()
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      goCoinIn() {
        this.$router.push({name: 'coinIn'})
      },
      goCoinOut() {
        this.$router.push({name: 'coinOut'})
      },
      goCoinInHistory() {
        this.$router.push({name: 'coinInHistory'})
      },
      goCoinOutHistory() {
        this.$router.push({name: 'coinOutHistory'})
      },
      goCoinHistory() {
        this.$router.push({name: 'coinHistory'})
      },


      myBalance(){
        platformCoin().then(res => {
          if(res.code===200){
            this.code = res.data.code;  //蚂蚁金币代码
            this.antCoinUnitPrice = res.data.sellPriceBenefit; //蚂蚁金币单价
            this.getMyCoin()
          }
        })
      },
      getMyCoin(){
        getAntIntegralWallet({userOpenid: this.userOpenId, code: this.code,walletType:0}).then(res => {
          this.antCoinBalance = res.data.totalAmount
          this.antCoinMoney = res.data.totalAmount * this.antCoinUnitPrice
        })
      },


      // 获取待结算
      getWaitSettle(){
        let req = {
          targetId: this.session('userOpenId'),
          targetType: 0,
          walletType: 'ANTCOIN',
        }
        getWaitSettle(req).then(res=>{
          this.waitSettle = res.data || 0
        })
      },
    }
  }
</script>

<style scoped lang="less">
  @url: 'https://fileqn.anttalk.vip/';
  .coin{
    .wallet-header{
      background-color: transparent;
      position: absolute;
      z-index: 9;
      width: 100%;
      .van-nav-bar__left{
        .van-icon{
          color: #fff !important;
        }
      }
      .van-nav-bar__title{
        color: #fff;
      }
    }
    .header{
      background: url("@{url}FukyP_m6y_-1U9VFmnsfXGipQAlE") no-repeat 50% 0;
      background-size: 100%;
      height: 187px;
      position: relative;
      text-align: center;
      color: white;
      padding-top: 82px;
      display: flex;
      .item{
        flex: 1;
        .title{
          line-height: 1;
          font-size: 13px;
          padding-bottom: 7px;
        }
        .num{
          font-size: 16px;font-weight: bold;
        }
      }
      span{
        padding: 0 6px;
      }
    }
    /*.tool{
      height: 71px;
      position: relative;
      .item-con{
        background-color: white;
        position: absolute;
        top: -30px;
        left: 24px;
        width: 328px;
        height: 81px;
        border-radius: 5px;
        display: flex;
        .item{
          flex: 1;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img{
            width: 37px;
            height: 37px;
            margin-bottom: 8px;
          }
          .title{
            color: rgb(43,43,43);
            font-size: 16px;
            line-height: 1;
          }
        }
        .gray-line{
          width: 1px;
          background: #ddd;
          margin: 11px 0;
        }
      }
    }*/
    .tool{
      height: 44px;
      position: relative;

      .cash-out-btn{
        position: absolute;width: 257px;height: 50px;left: 59px;top: -21px;
        display: inline-flex;align-items: center;justify-content: center;
        border-radius: 25px;background-color: #fff;
        .img{
          width: 33px;
          height: 32px;
          margin-right: 8px;
        }
        .title{
          color: rgb(43,43,43);
          font-size: 16px;
          line-height: 1;
        }
      }
    }

    .list-con{
      .list-con-img{
        width: 22px;
        height: 21px;
        vertical-align: text-bottom;
        margin: 0 10px 0 6px;
      }
      .list-con-text{
        font-size: 16px;
      }
    }
  }
</style>
<style lang="less">
  .coin{

  }
</style>
